import { Reveal } from "./Reveal";

const PRINCIPLES = [
  {
    num: "01",
    title: "Think beyond the obvious",
    desc: "Explore problems from different perspectives instead of settling for the first solution.",
  },
  {
    num: "02",
    title: "Build, test, improve",
    desc: "Turn ideas into tangible prototypes, learn from experimentation, and improve through iteration.",
  },
  {
    num: "03",
    title: "Show up consistently",
    desc: "Progress comes from doing the work, learning from setbacks, and returning to the challenge.",
  },
];

export const Approach = () => (
  <section id="approach" data-testid="approach-section" className="py-24 md:py-32 border-t border-white/10">
    <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] text-[#71717A] font-mono-alt">My Approach</p>
        <h2 className="font-heading text-4xl md:text-5xl tracking-tight leading-tight font-medium text-[#F9F9F9] mt-4">
          How I approach a challenge.
        </h2>
      </Reveal>

      <div className="mt-16">
        {PRINCIPLES.map((p, i) => (
          <Reveal key={p.num} delay={i * 0.08}>
            <div
              data-testid={`approach-${p.num}`}
              className="group grid grid-cols-12 gap-4 md:gap-8 items-baseline py-8 md:py-10 border-t border-white/10 last:border-b hover:bg-[#111111]/60 transition-colors duration-500 px-2 md:px-4 -mx-2 md:-mx-4"
            >
              <p className="col-span-2 md:col-span-1 font-mono-alt text-sm text-[#0EA5E9]">{p.num}</p>
              <h3 className="col-span-10 md:col-span-4 font-heading text-2xl md:text-3xl tracking-tight font-medium text-[#F9F9F9]">
                {p.title}
              </h3>
              <p className="col-span-10 col-start-3 md:col-span-6 md:col-start-7 text-sm md:text-base text-[#A1A1AA] leading-relaxed">
                {p.desc}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
